module.exports = __webpack_public_path__ + "img/background-platinum-large.8dd77664.svg";